var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import baseApi from "../api";
import resetStore from "../resetStore";
import { updateTokens } from "./slice";
const api = baseApi.injectEndpoints({
    endpoints: (build) => ({
        passwordLogin: build.mutation({
            query: (payload) => ({
                url: "security/login",
                method: "POST",
                body: payload,
            }),
            extraOptions: { withoutAuth: true },
            onQueryStarted(_, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { data } = yield queryFulfilled;
                    dispatch(updateTokens(data));
                });
            },
        }),
        integratorLogin: build.mutation({
            query: ({ integrator, token }) => ({
                url: `security/login/${integrator}`,
                method: "POST",
                body: { token },
            }),
            extraOptions: { withoutAuth: true },
            onQueryStarted(_, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { data } = yield queryFulfilled;
                    dispatch(updateTokens(data));
                });
            },
        }),
        logout: build.mutation({
            query: (payload) => ({
                url: "security/invalidate",
                method: "POST",
                body: { refreshToken: payload },
            }),
            onQueryStarted(_, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    yield queryFulfilled;
                    void dispatch(resetStore());
                });
            },
        }),
    }),
});
export const { usePasswordLoginMutation, useIntegratorLoginMutation, useLogoutMutation, } = api;
